// src/pages/Archive/index.jsx
import React, { useState, useEffect } from 'react';
import ArchiveItem from '../../component/ArchiveItem/index.jsx';
import { useAuth } from '../../context/AuthContext';
import { Button, Modal, message } from 'antd';
import './index.css';

const Archive = () => {
  const [groupedArticles, setGroupedArticles] = useState({});
  const [deleteModalVisible, setDeleteModalVisible] = useState(false);
  const [postToDelete, setPostToDelete] = useState(null);
  const { getAllPosts, getUserPosts, deletePost, user } = useAuth();

  // 按月份分组文章
  const groupArticlesByMonth = (articles) => {
    const grouped = {};
    
    articles.forEach(article => {
      if (article.date) {
        const date = new Date(article.date);
        // 检查日期是否有效
        if (isNaN(date.getTime())) return;
        
        const month = date.getMonth() + 1;
        const year = date.getFullYear();
        
        const key = `${year}年${month}月`;
        
        if (!grouped[key]) {
          grouped[key] = [];
        }
        
        grouped[key].push(article);
      }
    });
    
    // 按年份和月份排序
    const sortedGrouped = {};
    Object.keys(grouped)
      .sort((a, b) => {
        // 提取年份和月份进行比较
        const [yearA, monthA] = a.replace('年', '-').replace('月', '').split('-').map(Number);
        const [yearB, monthB] = b.replace('年', '-').replace('月', '').split('-').map(Number);
        
        if (yearA !== yearB) return yearB - yearA; // 年份降序
        return monthB - monthA; // 月份降序
      })
      .forEach(key => {
        // 对每个月份内的文章按日期排序
        sortedGrouped[key] = grouped[key].sort((a, b) => 
          new Date(b.date) - new Date(a.date)
        );
      });
    
    return sortedGrouped;
  };

  // 获取文章数据
  useEffect(() => {
    const allPosts = getAllPosts();
    const grouped = groupArticlesByMonth(allPosts);
    setGroupedArticles(grouped);
  }, [getAllPosts]);

  const handleDeleteClick = (post) => {
    setPostToDelete(post);
    setDeleteModalVisible(true);
  };

  const confirmDelete = () => {
    if (postToDelete) {
      deletePost(postToDelete.id);
      message.success('文章已删除');
      setDeleteModalVisible(false);
      setPostToDelete(null);
    }
  };

  const cancelDelete = () => {
    setDeleteModalVisible(false);
    setPostToDelete(null);
  };

  return (
    <div className="archive-page">
      <h1>文章归档</h1>
      
      {Object.keys(groupedArticles).length > 0 ? (
        Object.keys(groupedArticles).map(month => (
          <div key={month} className="archive-month">
            <div className="month-header">
              <span className="month-icon">📅</span>
              <span className="month-title">{month}</span>
            </div>
            
            <div className="articles-list">
              {groupedArticles[month].map(article => (
                <div key={article.id} style={{ position: 'relative' }}>
                  <ArchiveItem article={article} />
                  {user && article.authorId === user.id && (
                    <Button
                      type="link"
                      danger
                      size="small"
                      onClick={() => handleDeleteClick(article)}
                      style={{
                        position: 'absolute',
                        top: '10px',
                        right: '10px',
                        padding: '2px 8px',
                        fontSize: '12px'
                      }}
                    >
                      删除
                    </Button>
                  )}
                </div>
              ))}
            </div>
          </div>
        ))
      ) : (
        <p style={{ textAlign: 'center', color: '#dc2626', fontSize: '1.1rem', padding: '2rem' }}>
          暂无文章
        </p>
      )}

      <Modal
        title="确认删除"
        open={deleteModalVisible}
        onOk={confirmDelete}
        onCancel={cancelDelete}
        okText="确认"
        cancelText="取消"
      >
        <p>确定要删除文章 "{postToDelete?.title}" 吗？此操作不可恢复。</p>
      </Modal>
    </div>
  );
};

export default Archive;